import { gsap } from "gsap";
import { Container, IDestroyOptions, Point, Sprite, Texture } from "pixi.js";
import { CommonResourcesPackage } from "../../../../common/resources/CommonResourcesPackage";
import { CheckoutHourlyBonusResourcePackage } from "../resources/CheckoutHourlyBonusResourcePackage";
import { DicesResourcePackage } from "by/gamefactory/cityversetycoon/scenes/common/resources/DicesResourcePackage";
type TimeLine = gsap.core.Timeline;

export class DynamicBackground extends Container {
    private ICONS_VIEW_DESCRIPTION = new Array<IconViewDescription>();
    private icons: Array<Sprite>;
    private iconIdleAnimation: TimeLine;
    private readonly referenceWidth: number;
    private readonly referenceHeight: number;

    public constructor(
        commonResources: CommonResourcesPackage,
        dicesResources: DicesResourcePackage,
        checkoutHourlyBonusResources: CheckoutHourlyBonusResourcePackage,
        isWheel: boolean,
        referenceWidth: number,
        referenceHeight: number
    ) {
        super();
        this.iconIdleAnimation = new gsap.core.Timeline();
        this.referenceWidth = referenceWidth;
        this.referenceHeight = referenceHeight;
        if (!isWheel) {
            this.ICONS_VIEW_DESCRIPTION = new Array<IconViewDescription>(
                { percentPosition: new Point(0.23, 0.78), texture: commonResources.assets_common_ui_dices_dice_01_png, angle: 72.19, size: new Point(288.64, 362.2) },
                { percentPosition: new Point(0.04, 0.6), texture: dicesResources.assets_views_dices_dice_02_png, angle: 65.04, size: new Point(212, 216) },
                { percentPosition: new Point(-0.14, 0.31), texture: dicesResources.assets_views_dices_dice_04_png, size: new Point(342, 348) },
                { percentPosition: new Point(0.44, 0.38), texture: dicesResources.assets_views_dices_dice_02_png, angle: 65.04, size: new Point(137.69, 140.29) },
                { percentPosition: new Point(0.21, 0.15), texture: dicesResources.assets_views_dices_dice_07_png, size: new Point(207, 207) },
                { percentPosition: new Point(-0.11, -0.13), texture: dicesResources.assets_views_dices_dice_04_png, size: new Point(408, 416) },
                { percentPosition: new Point(1.23, -0.05), texture: dicesResources.assets_views_dices_dice_05_png, angle: 119.07, size: new Point(354, 427) },
                { percentPosition: new Point(0.89, 0.43), texture: dicesResources.assets_views_dices_dice_05_png, size: new Point(354, 427) },
                { percentPosition: new Point(0.9, 0.67), texture: dicesResources.assets_views_dices_dice_02_png, angle: -8.54, size: new Point(137.69, 140.29) },
                { percentPosition: new Point(1.08, 0.81), texture: dicesResources.assets_views_dices_dice_06_png, angle: 90.5, size: new Point(231, 244.17) },
                { percentPosition: new Point(0.37, 0.89), texture: commonResources.assets_common_ui_dices_dice_03_png, size: new Point(287, 214) },
            );
        }
        else {
            this.ICONS_VIEW_DESCRIPTION = new Array<IconViewDescription>(
                { percentPosition: new Point(-0.23, 0.91), texture: checkoutHourlyBonusResources.assets_views_checkout_hourly_bonus_wheels_wheel_1_png, angle: -36.44, size: new Point(323.61, 341.87) },
                { percentPosition: new Point(0.05, 0.61), texture: dicesResources.assets_views_dices_dice_02_png, angle: 65.04, size: new Point(212, 216) },
                { percentPosition: new Point(0.19, 0.47), texture: checkoutHourlyBonusResources.assets_views_checkout_hourly_bonus_wheels_wheel_2_png, angle: -36.44, size: new Point(124, 131) },
                { percentPosition: new Point(-0.1, 0.21), texture: checkoutHourlyBonusResources.assets_views_checkout_hourly_bonus_wheels_wheel_3_png, angle: 15.53, size: new Point(316.84, 335.7) },
                { percentPosition: new Point(0.27, 0.13), texture: dicesResources.assets_views_dices_dice_07_png, size: new Point(207, 207) },
                { percentPosition: new Point(-0.2, -0.1), texture: dicesResources.assets_views_dices_dice_04_png, size: new Point(408, 416) },
                { percentPosition: new Point(0.54, -0.03), texture: checkoutHourlyBonusResources.assets_views_checkout_hourly_bonus_wheels_wheel_4_png, angle: 46.79, size: new Point(84.26, 97.06) },
                { percentPosition: new Point(1.27, -0.05), texture: dicesResources.assets_views_dices_dice_05_png, angle: 119.07, size: new Point(354, 427) },
                { percentPosition: new Point(0.89, 0.43), texture: dicesResources.assets_views_dices_dice_05_png, size: new Point(354, 427) },
                { percentPosition: new Point(0.9, 0.7), texture: checkoutHourlyBonusResources.assets_views_checkout_hourly_bonus_wheels_wheel_5_png, angle: -36.44, size: new Point(92.83, 98.07) },
                { percentPosition: new Point(0.93, 0.83), texture: checkoutHourlyBonusResources.assets_views_checkout_hourly_bonus_wheels_wheel_6_png, angle: 34.4, size: new Point(170.05, 179.65) },
                { percentPosition: new Point(0.39, 0.9), texture: commonResources.assets_common_ui_dices_dice_03_png, size: new Point(287, 214) }
            );
        }
        this.icons = [];
        this.build();
    }

    private build(): void {
        this.ICONS_VIEW_DESCRIPTION.forEach((item) => {
            const icon = new Sprite(item.texture);
            icon.width = item.size.x;
            icon.height = item.size.y;
            if (item.angle) {
                icon.angle = item.angle;
            }
            icon.position.set(this.referenceWidth * item.percentPosition.x - this.referenceWidth * 0.5, this.referenceHeight * item.percentPosition.y - this.referenceHeight * 0.5);
            this.icons.push(icon);
            this.addChild(icon);
        });
    }

    public async playIdleAnimation(): Promise<void> {
        this.icons.forEach((icon) => {
            this.iconIdleAnimation.to(icon, {
                x: "+=25",
                y: `random(${icon.y - 20}, ${icon.y + 20}, 1)`,
                duration: "random(1.5, 2)",
                delay: "random(0, 0.2)",
                repeat: -1,
                repeatRefresh: true,
                yoyo: true,
                ease: "sine.inOut"
            }, "<");
        });
        await this.iconIdleAnimation.play();
        this.iconIdleAnimation.clear();
    }

    public async playStartAnimation(): Promise<void> {
        this.icons.forEach((icon) => {
            this.iconIdleAnimation.fromTo(icon.scale, { x: 0, y: 0, }, { x: icon.scale.x, y: icon.scale.y, duration: 0.3, delay: 0.1 }, "<");
        })
    }

    public hide(): void {
        this.iconIdleAnimation.pause(0);
        this.iconIdleAnimation.clear();
        this.visible = false;
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.iconIdleAnimation?.kill();
        super.destroy(options);
    }
}

type IconViewDescription = {
    percentPosition: Point;
    texture: Texture;
    angle?: number;
    size: Point;
}
